var config = require('../config.js')
module.exports = {
    activityList: config.host + '/market/api/v1/activity/list/c', //获取所有活动信息
    activityList2: config.host + '/market/api/v1/activity/firstList/c', //获取所有活动信息
    // activityList2: config.host + '/market/api/v1/activity/firstList/v4/c', //获取所有活动信息
    activityShowList: config.host + '/market/api/v1/activity/showList/c', //获取演出下的活动信息
    activityShowListAll: config.host + '/market/api/v1/activity/showListId/c', //获取活动下的演出信息
    activityShowList2: config.host + '/market/api/v1/activity/activityByShowId/c', //获取演出下的活动信息
    // activityShowList2: config.host + '/market/api/v1/activity/activityByShowId/v4/c', //获取演出下的活动信息

    

    timeLimitedDiscountList: config.host + '/market/api/v1/timeLimitedDiscount/list/c', //获取限时活动列表
    timeLimitedDiscountList2: config.host + '/market/api/v1/timeLimitedDiscount/indexList/c', //获取限时活动列表
    // timeLimitedDiscountList2: config.host + '/market/api/v1/timeLimitedDiscount/indexList/v4/c', //获取限时活动列表
    
    timeLimitedDiscountListByTimeLimited: config.host + '/market/api/v1/timeLimitedDiscount/listByTimeLimited/c', //根据限时id获取演出
    timeLimitedDiscountShowList: config.host + '/market/api/v1/timeLimitedDiscount/showList/c', //获取演出下的限时活动信息
    timeLimitedDiscountShowList2: config.host + '/market/api/v1/timeLimitedDiscount/timeLimitedByShowId/c', //获取演出下的限时活动信息
    // /market/api/v1/timeLimitedDiscount/timeLimitedByShowId/c?page=1&size=1&ShowId=1780413054535200770' \
    // timeLimitedDiscountShowList2: config.host + '/market/api/v1/timeLimitedDiscount/timeLimitedByShowId/v4/c', //获取演出下的限时活动信息
}